namespace SPA
{
	export namespace Realtor
	{
		export namespace gui
		{
			export class RealtorSeller
			{
				public static Build(object: RealtorObjectModel): JQuery
				{
					const company = app.getAuthenticationManager().getCompany();
					const employee = app.getAuthenticationManager().getEmployee();

					let address;
					let email;
					let cell;
					let mobile;

					if (employee) {
						address = _.find(employee.Address, (a) => a.AddressType === 'PostalAddress');
						email = _.find(employee.Address, (a) => a.AddressType === 'Email');
						cell = _.find(employee.Address, (a) => a.AddressType === 'Phone' && a.KindOf === 'cell');
						mobile = _.find(employee.Address, (a) => a.AddressType === 'Phone' && a.KindOf === 'mobile');
					}

					const html = $(`<fieldset class="form-horizontal" id="object-${object.Object.ID}-realtorseller">`)
						.append('<legend>Makler & Makler-Verkäufer <small>(Ansprechpartner)</small></legend>')
						.append($('<div class="row">')
							.append(SPA.gui.Bootstrap.Column('col-sm-4',
								'<label class="control-label">Firma</label>',
								`<p class="form-control-static">${company.Name}</p>`
							))
							.append(SPA.gui.Bootstrap.Column('col-sm-4',
								'<label class="control-label">Mitarbeiter</label>',
								`<p class="form-control-static">${employee ? employee.Name + ' ' + employee.Surname : ''}</p>`
							))
						)
						.append($('<div class="row">')
							.append('<h3 class="col-xs-12">Makler-Verkäufer <small>(Ansprechpartner)</small></h3>')
							.append(SPA.gui.Bootstrap.Column('col-sm-6',
								'<label class="control-label">Name</label>',
								`<p class="form-control-static">${object.Creator.Name + ' ' + object.Creator.Surname}</p>`
							))
							.append(SPA.gui.Bootstrap.Column('col-sm-6',
								'<label class="control-label">Anschrift</label>',
								`<p class="form-control-static">${address ? address.display : ''}</p>`
							))
						)
						.append($('<div class="row">')
							.append(SPA.gui.Bootstrap.Column('col-sm-4',
								'<label class="control-label">E-Mail</label>',
								`<p class="form-control-static">${email ? email.display : ''}</p>`
							))
							.append(SPA.gui.Bootstrap.Column('col-sm-4',
								'<label class="control-label">Telefon</label>',
								`<p class="form-control-static">${cell ? cell.display : ''}</p>`
							))
							.append(SPA.gui.Bootstrap.Column('col-sm-4',
								'<label class="control-label">Mobil</label>',
								`<p class="form-control-static">${mobile ? mobile.display : ''}</p>`
							))
						);

					return $(html);
				}
			}
		}
	}
}
